import React from 'react';
import { node } from 'prop-types';
import { LocaleProvider } from '@context/locale';
import { ResolutionProvider } from '@context/resolution';
import { GlobalVariableProvider } from '@context/globalvariables';

function ContextProvider({ children }) {
  return (
    <GlobalVariableProvider>
      <ResolutionProvider>
        <LocaleProvider>{children}</LocaleProvider>
      </ResolutionProvider>
    </GlobalVariableProvider>
  );
}

ContextProvider.propTypes = {
  children: node.isRequired,
};

export default ContextProvider;
